module.exports = __webpack_public_path__ + "static/media/meter3.fff99105.svg";